export default __webpack_public_path__ + "static/media/meat.8d9a323d.png";